import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-event-trigger",
  "use": "icon-event-trigger-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-event-trigger\"><path d=\"m7.05 15.692 3.778-11.654c.2-.62.776-1.038 1.426-1.038h7.962a1 1 0 0 1 .936 1.352L18.66 11h5.464a1 1 0 0 1 .792 1.612L12.82 28.614c-.682.902-2.104.156-1.746-.918L14.626 17H8a1 1 0 0 1-.95-1.308\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol